import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Card,
  Badge,
  Tag,
} from '@lockerpm/design';

import {
  PlusOutlined,
} from "@ant-design/icons";

import { blue, purple, gray, green } from '@ant-design/colors';

import itemsComponents from "../../../../components/items";
import commonComponents from "../../../../components/common";

import {
  convertDateTime,
  projectMemberRole
} from '../../../../utils/common';

const BoxData = (props) => {
  const { RouterLink, TextCopy, ProgrammingLanguage } = itemsComponents;
  const { OnboardingTooltip } = commonComponents;
  const { t } = useTranslation()
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace)

  const {
    item = {},
    isSelect = false,
    isCreate = false,
    isSelected = false,
    onCreate = () => {},
    onSelect = () => {}
  } = props;

  const projectRole = useMemo(() => {
    return projectMemberRole(item?.role)
  }, [item])

  return (
    <Card
      className="h-full cursor-pointer"
      bodyStyle={{ height: '100%' }}
      style={{
        minHeight: 164,
        borderColor: isSelected ? green.primary : `var(--border-color)`
      }}
    >
      {
        isCreate ? <OnboardingTooltip
          title={t('onboarding.create_project')}
          placement="bottomRight"
          content={<div
            className="flex items-center justify-center h-full cursor-pointer"
            onClick={onCreate}
          >
            <div className="text-center text-primary">
              <PlusOutlined />
              <p>{t('button.new_project')}</p>
            </div>
          </div>}
        /> : <div
          onClick={() => onSelect(item)}
        >
          <div className="flex items-center justify-between">
            {
              isSelect ? <p className="text-lg font-semibold mr-2">
                {item.name}
              </p> : <RouterLink
                className="text-lg font-semibold mr-2"
                routerName={'PROJECT_SECRETS'}
                routerParams={{ workspace_id: selectedWorkspace?.id, project_id: item.id }}
                routerQuery={{}}
                label={item.name}
              />
            }
            <ProgrammingLanguage
              name={item.programming_language}
              isShowLabel={false}
              width={28}
              height={28}
            />
          </div>
          <div className="flex items-center mb-2 mt-4">
            <p className="mr-2">{t('secrets.title')}:</p>
            <Badge
              count={item.total_secret}
              color={blue[0]}
              showZero
              overflowCount={99}
              style={{ color: blue[6], minWidth: 32 }}
            />
          </div>
          <div className="flex items-center mb-2">
            <p className="mr-2">{t('environments.title')}:</p>
            <Badge
              count={item.total_environment}
              showZero
              color={purple[0]}
              overflowCount={99}
              style={{ color: purple[6], minWidth: 32 }}
            />
          </div>
          <div className="flex items-center">
            <p className="mr-2">{t('common.role')}:</p>
            <Tag
              color={projectRole.color}
            >
              <TextCopy
                value={t(projectRole.label)}
              />
            </Tag>
          </div>
          <div className="flex items-center mt-4">
            <p className="mr-2" style={{ color: gray[2] }}>
              {t('common.created_time')}:
            </p>
            <TextCopy
              color={gray[2]}
              value={convertDateTime(item.creation_date, 'DD-MM-YYYY')}
            />
          </div>
        </div>
      }
    </Card>
  );
}

export default BoxData;
